/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import Form from "react-bootstrap/Form";
import Image from "react-bootstrap/Image";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import Card from "../../../../../components/Cards/Card";
import { getDomainBrandIdentity } from "../../../../../store/actions/domain-brand.action";
import {
  fetchAppLanguage,
  fileToBase64,
} from "../../../../../utils/helpers/logicHelper";
import { fetchSubDomain } from "../../../../../utils/services/baseUrl";
import { ManagerService } from "../../../../../utils/services/manager.service";

function Logo({ dictionary, domainBrand }) {
  const dispatch = useDispatch();
  const subdomain = fetchSubDomain();
  const selectedLanguage = fetchAppLanguage();
  const [open] = useState(false);
  const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState(false);
  const [bgImage, setBgImage] = useState(domainBrand?.domainBrand?.logo);
  const [fileChosen, setFileChosen] = useState("No file chosen");

  const handleImageChange = async (e) => {
    const file = e?.target?.files[0];
    setFileChosen(e?.target?.files[0]?.name);
    const base64 = await fileToBase64(file);
    setBgImage(base64);
  };

  const updateBrandSettings = async (payload) => {
    setLoading(true);
    try {
      const response = await ManagerService.updateBrandSettings(payload);
      if (response.status === 200) {
        toast.success(response.data.message);
        dispatch(getDomainBrandIdentity(subdomain, selectedLanguage["id"]));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <>
      <Card>
        <ul className="list-group">
          <li
            className="list-group-item collapse-text text-uppercase fw-bold"
            onClick={() => setLogo(!logo)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
            style={{ cursor: "pointer", borderBottom: "0px solid" }}
          >
            {logo ? (
              <i className="fa fa-minus" aria-hidden="true" />
            ) : (
              <i className="fa fa-plus" aria-hidden="true" />
            )}{" "}
            &nbsp;
            {dictionary ? dictionary["para_logo_upload"] : "LOGO UPLOAD"}
          </li>
          <Collapse in={logo}>
            <div id="example-collapse-text" className="px-3">
              <h6 className="fw-bold">
                {dictionary
                  ? dictionary["para_upload_your_company_logo_here"]
                  : `Upload your company logo here. Recommended and maximum allowed dimensions are 370x50. Other will be resized.`}
              </h6>

              <div className="form-row py-4">
                {bgImage !== null && (
                  <div className="col-lg-12 col-md-12 mb-3 d-flex align-items-center justify-content-center">
                    <Image
                      fluid
                      src={bgImage}
                      className="mx-auto"
                      style={{
                        height: 300,
                        width: 300,
                        objectFit: "contain",
                      }}
                    />
                  </div>
                )}
                <div className="col-lg-6 col-md-6 mb-3">
                  <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label className="btn btn-primary">
                      {dictionary
                        ? dictionary["WO_UPLOA_-789878888"]
                        : "UPLOAD"}
                    </Form.Label>
                    <Form.Control
                      type="file"
                      hidden
                      onChange={(e) => {
                        handleImageChange(e);
                      }}
                    />
                  </Form.Group>
                </div>
                <div className="col-lg-6 col-md-5 mb-3 d-flex align-middle justify-content-center">
                  <span className="align-middle pt-4">{fileChosen}</span>
                </div>
              </div>
              <div className="form-row py-4">
                <div className="col-lg-6 col-md-6 float-start mb-3" />
                <div className="col-lg-6 col-md-6 float-end mb-3">
                  <button
                    onClick={() => updateBrandSettings({ logo: bgImage })}
                    className="login100-form-btn btn-primary fw-bold text-uppercase"
                  >
                    {dictionary
                      ? dictionary["para_upload_image"]
                      : "UPLOAD IMAGE"}
                    &nbsp;&nbsp;
                    {loading && (
                      <>
                        <i className="fa fa-spinner fa-spin" />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </ul>
      </Card>
    </>
  );
}

export default Logo;
